/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_NameInputs */



/**
* | output |
* | --- |
* | "Insert speaker name" |
*
* @param {Insert_Speaker_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_name = /** @type {((inputs?: Insert_Speaker_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer le nom de l'intervenant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprechernamen einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il nome dell'oratore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте имя докладчика")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar el nombre del orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入演讲者姓名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカー名を挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता का नाम डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira o nome do palestrante")
	return /** @type {LocalizedString} */ ("Insert speaker name")
});